// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.
import { memo, useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { useNavigate, useParams } from "react-router-dom";
import { loginForAClient } from "../../services/hwai_user.service";
import {
  loginRequest,
  loginFailure,
  showTour,
  loginSuccess,
  updateFeedbackStatus,
  showFeedBackform,
  addLogOrg,
  addOrgs,
  updateClientName,
  setDashboardPopUp,
  floatingChatBotPop,
  setShowLaunchCampaign,
  setIsWebinarPopActive,
  setIsETPredictionPopActive,
  setIsAepDataUpdatePopActive,
  setSlidingCardsSalesContent,
  setLandingLayout,
} from "../../store/auth/action";
import { getAllClients } from "../../services/hwai_user.service";
import { useSelector, useDispatch } from "react-redux";
import ClientSelectDropDown from "./ClientSelectDropDown";
import { logAmplitudeEvent } from "../../utils/amplitude/functions";
import amplitude from "../../utils/amplitude/initiate";
import { clearStorage } from "../../utils/clearstore";
import { getSlidingCardsSalesContentAPI } from "../../services/cards.service";
// import amplitude from "../../utils/amplitude";
// import environment from "../../config/environment";

const OrgsDropDown = ({ defaultOpen = false }) => {
  const { clientID } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [defaultValue, setDefaultValue] = useState({});
  const { clientname, hwai_user_token, orgs, logOrg, userDetails } =
    useSelector((state) => ({
      clientname: state.clientname,
      hwai_user_token: state.hwai_user_token,
      orgs: state.orgs,
      logOrg: state.logOrg,
      userDetails: state.userDetails,
    }));

  async function clientLogin(logOrg) {
    try {
      dispatch(loginRequest());
      const payload = { clientid: logOrg._id };
      if (!payload.clientid) {
        dispatch(loginFailure("No client was selected"));
      }
      const response = await loginForAClient(payload);

      const userData = response.data.user;
      const logo = userData.clientId.logo;
      const loggedClientDetails = userData.clientId;
      const subsData = response.data.subscriptions;

      const trendingsData = response.data.trendings;
      const sessionData = response.session;
      const bannerData = userData.bannerId;
      const favData = response.data.favourites;
      const notData = response.data.notification;
      const newsData = response.data.newsinfo;
      const whData = userData.whitepaperIds;
      const tempToken = sessionData.userId;
      const addsData = userData.addIds;
      const feedbackstatus = response.data.feedback;
      dispatch(setLandingLayout(response.data.landingLayout || null));
      dispatch(showTour(userData?.showTour));
      const tempuserDetails = {
        trendingConfig: userData.trendingConfig,
        userSQLId: userData?.userSQLId,
        userName: userData?.userName,
        clientId: userData?.clientId,
        email: userData?.email,
        firstName: userData?.firstName,
        lastName: userData?.lastName,
        address: userData?.address,
        mobile: userData?.mobile,
        about: userData?.about,
        permissions: userData?.permissions,
        jobTitle: userData?.jobTitle,
        department: userData?.department,
        userId: userData?._id,
        showTour: userData?.showTour,
        sessionId: response.session._id,
        permission: userData?.permissions,
        client: userData?.clientId?.clientname,
      };
      
      const slidingCardsSalesContent = await getSlidingCardsSalesContentAPI({clientId: userData?.clientId?._id});
      dispatch(setSlidingCardsSalesContent(slidingCardsSalesContent));
      // if (userData && subsData.length > 0) {
      dispatch(
        loginSuccess(
          tempToken,
          bannerData,
          favData,
          notData,
          whData,
          subsData,
          trendingsData,
          tempuserDetails,
          sessionData,
          newsData,
          addsData,
          logo,
          loggedClientDetails
        )
      );

      dispatch(showFeedBackform());
      dispatch(updateFeedbackStatus(feedbackstatus));
      dispatch(setDashboardPopUp(userData?.clientId?.config?.dashboardpopup));
      dispatch(floatingChatBotPop(userData?.clientId?.config?.isFloatingBtnEnabled));
      userData?.clientId?.config?.etPredictionPopupEnabled ? dispatch(setIsETPredictionPopActive(true)) :  dispatch(setIsWebinarPopActive(true));
      dispatch(setIsAepDataUpdatePopActive(true));
      dispatch(setShowLaunchCampaign(userData?.clientId?.config?.showLaunchCampaign));

      if (defaultValue._id) {
        navigate(`/${defaultValue._id}`);
      } else {
        navigate(`/${clientID}`);
      }
      // } else {
      //   const demoClient = orgs.find(
      //     (client) => client.name === "Demo" || client.clientname === "Demo"
      //   );

      //   setDefaultValue(demoClient);
      //   dispatch(addLogOrg(demoClient));
      //   dispatch(updateClientName(demoClient?.clientname));
      //   navigate(`/${demoClient._id}`);
      //   //reload page
      //   // window.location.reload();
      //   dispatch(loginFailure("Client is not configured yet"));
      // }
    } catch (err) {
      console.log(err, "error object");
      if (err?.response?.status) {
        switch (err.response.status) {
          case 404:
            dispatch(loginFailure("Client not found"));
            break;
          case 401:
            //clear cache
          
            dispatch(
              loginFailure("Invalid Client Selection or You have no access")
            );
            clearStorage();
            window.location.reload();
            break;
          default:
            dispatch(loginFailure(err.response.data));
        }
      }
    }
  }

  useEffect(() => {
    if (!hwai_user_token) {
      navigate("/login");
    } else if (logOrg._id && defaultValue?._id && logOrg?._id !== clientID) {
      clientLogin(logOrg);
    }
  }, [defaultValue]);

  async function populateOrganizations() {
    const response = await getAllClients();
    dispatch(addOrgs(response.clients));
  }

  useEffect(() => {
    if (!hwai_user_token) {
      navigate("/login");
    } else if (orgs.length === 0) {
      populateOrganizations();
    }
  }, [hwai_user_token]);

  useEffect(() => {
    let matchedOrg;
    if (clientID) {
      matchedOrg = orgs.find((obj) => obj["_id"] === clientID);
    } else {
      matchedOrg = orgs.find((obj) => obj["clientname"] === clientname);
    }
    setDefaultValue(matchedOrg);
  }, []);

  return (
    <div className="w-full">
      <ClientSelectDropDown
        defaultOpen={defaultOpen}
        options={orgs}
        checked={defaultValue}
        setChecked={(i) => {
          logAmplitudeEvent(amplitude, "Client Switched", { clientName: i?.clientname, clientId: i?._id,eventTimestamp:new Date().toLocaleString('en-US', { timeZone: 'UTC' }) });
          setDefaultValue(i);
          dispatch(addLogOrg(i));
          // environment === "PROD" && amplitude.track('Client Selected',
          //   {
          //     'client_name': i?.clientname,
          //     'client_Id': i?.clientSQLId
          //   });
          dispatch(updateClientName(logOrg?.clientname));
        }}
      />
    </div>
  );
};

export default memo(OrgsDropDown);
